import { RootState } from 'store';

export const selectUserIsLoggedIn = (state: RootState) => state.user.isLoggedIn;

export const selectUserIsLoading = (state: RootState) => state.user.isLoading;

export const selectUserData = () => (state: RootState) => state.user.user;
